import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import Iframe from "react-iframe";

class GetHelpL1 extends Component {
  // const { push } = React.useContext(RouterContext);

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <Layer
        full={true}
        position="center"
        height="medium"
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
      >
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                basis="xlarge"
                direction="column"
                gap="medium"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/*  <Button
                    label="Back"
                    icon={<FormPrevious />}
                    onClick={() => push("/gethelp-live")}
                  /> */}
                  <Heading margin="none">Get Help - HTTP 404 Error</Heading>
                </Header>

                <Box
                  align="stretch"
                  justify="center"
                  pad="medium"
                  gap="large"
                  direction="column"
                >
                  <Card hoverIndicator>
                    <CardHeader
                      align="start"
                      direction="column"
                      justify="start"
                      flex
                    >
                      <Box align="center" justify="center" direction="row">
                        <Heading size="small" level="4">
                          The Issue:
                        </Heading>
                      </Box>
                      <Box align="center" justify="center" direction="row">
                        <Paragraph size="medium">
                          When trying to launch second time demo via launch
                          button the HTTP 404 error may occur .
                        </Paragraph>
                        <Image
                          src="/img/GetHelp/GHL1-404error.png
"
                          fit="contain"
                        />
                      </Box>
                    </CardHeader>
                    <CardBody
                      direction="column"
                      justify="start"
                      align="stretch"
                    >
                      <Heading size="small" level="4">
                        The Resolution:
                      </Heading>
                      <Paragraph size="medium" textAlign="start" fill>
                        Change URL (https://xxx-access.hpevrnet.com/cgi/login),
                        replacing login by logout. Now run updated URL
                        (https://xxx-access.hpevrnet.com/cgi/logout)
                      </Paragraph>
                      <Image
                        src="/img/GetHelp/GHL1-404.png
"
                        fit="contain"
                      />
                      <Paragraph size="medium" fill>
                        Launch again your demo from my upcoming demonstrations
                        in HPE Demo Portal - My Upcoming demos
                      </Paragraph>
                      <Paragraph size="medium" fill>
                        See the corresponding video:
                      </Paragraph>
                      <Box
                        align="center"
                        justify="center"
                        pad="large"
                        responsive={false}
                        flex="grow"
                        height="large"
                      >
                        <Iframe
                          url="https://players.brightcove.net/5340004215001/default_default/index.html?videoId=6184094492001"
                          //position="absolute"
                          width="600px"
                          height="450px"
                          // id="myId"
                          // height="auto"
                          //styles={{ height: "25px" }}
                        />
                      </Box>
                    </CardBody>
                    <CardFooter
                      align="center"
                      direction="row"
                      flex={false}
                      justify="between"
                      gap="medium"
                      pad="small"
                    >
                      <Text size="xsmall">#GH-L1</Text>
                    </CardFooter>
                  </Card>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default GetHelpL1;
